import { render, staticRenderFns } from "./DashboardClassificator.vue?vue&type=template&id=da3b8a34&scoped=true"
import script from "./DashboardClassificator.vue?vue&type=script&lang=js"
export * from "./DashboardClassificator.vue?vue&type=script&lang=js"
import style0 from "./DashboardClassificator.vue?vue&type=style&index=0&id=da3b8a34&prod&lang=scss&scoped=true"
import style1 from "./DashboardClassificator.vue?vue&type=style&index=1&id=da3b8a34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3b8a34",
  null
  
)

export default component.exports